module.exports = __webpack_public_path__ + "img/3.01c2b3a8.png";